import { ApolloLink } from 'apollo-link';
import { onError } from 'apollo-link-error';
import { ApolloClient } from 'apollo-client';
import { RetryLink } from 'apollo-link-retry';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createUploadLink } from 'apollo-upload-client';

// import { API_BASE_URI, ORIGIN, BOOKER } from '../constants';

/**
 * GRAPHQL APOLLO CLIENT
 */
const httpLink = createUploadLink({
  // uri: `${API_BASE_URI}/graphql`,
  uri: () => `${global.masterBasePath}/graphql`,
});

// return the headers to the context so httpLink can read them
const authLink = setContext((_, {
  headers,
  accessToken,
  sessionToken,
  golfId,
}) => {
  const newHeaders = { ...headers };
  const { booker, origin, apiVersion } = global;
  if (golfId) newHeaders['x-golf'] = golfId;
  if (booker) newHeaders['x-booker'] = booker;
  if (origin) newHeaders['x-origin'] = origin;
  if (apiVersion) newHeaders['x-version'] = apiVersion;
  if (accessToken) newHeaders['x-access-token'] = accessToken;
  if (sessionToken) newHeaders['x-session-token'] = sessionToken;
  return { headers: newHeaders };
});

const retryLink = new RetryLink({
  delay: {
    initial: 300,
    max: Infinity,
    jitter: true,
  },
  attempts: { max: 3 },
});

const errorLink = onError(({
  response,
  graphQLErrors,
  networkError,
  // operation,
  // forward,
}) => {
  if (graphQLErrors) {
    // console.log('graphQLErrors', graphQLErrors);
    let hasError = false;
    for (let i = 0; i < graphQLErrors.length; i += 1) {
      const {
        message,
        extensions,
        // locations,
        // path,
      } = graphQLErrors[i];
      switch (extensions && extensions.code) {
        // case 'UNAUTHENTICATED': {
        //   // error code is set to UNAUTHENTICATED
        //   // when AuthenticationError thrown in resolver
        //
        //   // modify the operation context with a new token
        //   const oldHeaders = operation.getContext().headers;
        //   operation.setContext({
        //     headers: {
        //       ...oldHeaders,
        //       authorization: getNewToken(),
        //     },
        //   });
        //   // retry the request, returning the new observable
        //   return forward(operation);
        // }
        default:
          if (response && !hasError) {
            response.errors = [{ message: message || 'errors.internal' }];
            hasError = true; // only one error
          }
      }
    }
  }
  if (networkError) {
    // console.log('networkError', networkError, response);
    if (response) response.errors = [{ message: 'errors.network' }];
  }
  return null;
});

const apolloClient = new ApolloClient({
  link: ApolloLink.from([
    authLink,
    retryLink,
    errorLink,
    httpLink,
  ]),
  cache: new InMemoryCache(),
});

export default apolloClient;
